import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";



export var AddTestRes;
export const AddTestTodo = createAsyncThunk('adminAddTest', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'admin/test',
            data: {
                "test_name": data?.test,
                "url_name": data?.url,
                "company_id": localStorage.getItem('companyId'),
                "status": data?.status,
                "added_by": localStorage.getItem('user_id'),
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return AddTestRes = res.data

    } catch (error) {
        return AddTestRes = error.response.data
    }
})